// src/pages/UsageGuideTabs.jsx
import React, { useState, useId, useEffect, useRef } from "react";
import AnalyzerGuidePage from "./AnalyzerGuidePage";
import PartyGuidePage from "./PartyGuidePage";

const TABS = [
  { key: "analyzer", label: "전투 분석 기록 가이드", Component: AnalyzerGuidePage },
  { key: "party", label: "공격대 전투 분석 가이드", Component: PartyGuidePage },
];

export default function UsageGuideTabs() {
  const [active, setActive] = useState("analyzer");
  const tablistId = useId();
  const tabsRef = useRef({});

  // URL 해시로 초기 탭 선택 (#party 또는 #analyzer)
  useEffect(() => {
    const hash = window.location.hash?.replace("#", "");
    if (hash && TABS.some(t => t.key === hash)) setActive(hash);
  }, []);

  // 탭 전환 시 URL 해시 업데이트
  useEffect(() => {
    if (window.location.hash !== `#${active}`) {
      window.history.replaceState(null, "", `#${active}`);
    }
  }, [active]);

  // 키보드 네비게이션 (좌우 화살표)
  const onKeyDown = (e) => {
    const idx = TABS.findIndex(t => t.key === active);
    if (e.key === "ArrowRight") {
      const next = (idx + 1) % TABS.length;
      setActive(TABS[next].key);
      tabsRef.current[TABS[next].key]?.focus();
      e.preventDefault();
    } else if (e.key === "ArrowLeft") {
      const prev = (idx - 1 + TABS.length) % TABS.length;
      setActive(TABS[prev].key);
      tabsRef.current[TABS[prev].key]?.focus();
      e.preventDefault();
    }
  };

  const ActivePanel = TABS.find(t => t.key === active)?.Component ?? AnalyzerGuidePage;

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8 lg:py-8 flex flex-col dark:bg-black">
      {/* 탭 리스트 */}
      <div
        role="tablist"
        aria-label="사용 가이드 탭"
        id={tablistId}
        className="inline-flex rounded-xl border border-zinc-200 bg-zinc-100 p-1 dark:border-white/10 dark:bg-zinc-800 mr-auto ml-auto md:ml-auto md:mr-0"
        onKeyDown={onKeyDown}
      >
        {TABS.map(({ key, label }) => {
          const selected = key === active;
          return (
            <button
              key={key}
              role="tab"
              aria-selected={selected}
              aria-controls={`panel-${key}`}
              id={`tab-${key}`}
              ref={(el) => (tabsRef.current[key] = el)}
              onClick={() => setActive(key)}
              className={[
                "px-3 sm:px-4 py-2 text-sm font-medium rounded-lg outline-none transition",
                selected
                  ? "bg-white text-indigo-600 shadow dark:bg-zinc-900"
                  : "text-zinc-600 hover:text-indigo-500 hover:bg-white/70 dark:text-zinc-300 dark:hover:bg-zinc-700/60",
                "focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-zinc-900",
              ].join(" ")}
            >
              {label}
            </button>
          );
        })}
      </div>

      {/* 탭 패널 */}
      <div
        role="tabpanel"
        id={`panel-${active}`}
        aria-labelledby={`tab-${active}`}
        className="mt-5 md:mt-0 rounded-xl"
      >
        {/* 내부 컴포넌트는 자체로 카드/섹션 레이아웃을 가지고 있으므로 그대로 렌더 */}
        <ActivePanel />
      </div>
    </div>
  );
}
